function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = event => resolve(event.target.result);
    reader.readAsText(file);
  });
}

export default readFile;
